import { StringKey } from '../../../../lang/string-key.const';
import { TemplateFieldType } from './mapping-editor.const';

export const SIGNATURE_FIELD_TYPE_OPTIONS: TemplateFieldType[] = [
  TemplateFieldType.SIGNATURE,
  TemplateFieldType.DATE_SIGNED,
  TemplateFieldType.INITIAL,
  TemplateFieldType.TEXT,
];

export const SIGNATURE_FIELD_TYPE_LABEL: Record<TemplateFieldType, StringKey> = {
  [TemplateFieldType.SIGNATURE]: 'SIGNATURE',
  [TemplateFieldType.DATE_SIGNED]: 'DATE_SIGNED',
  [TemplateFieldType.INITIAL]: 'INITIAL',
  [TemplateFieldType.TEXT]: 'TEXT',
};
